// src/products/dataroom/components/SetupWizard/SimpleSetupTrigger.js
import React, { useState } from 'react';
import { Settings, Building2, Users, UserPlus } from 'lucide-react';
import DataroomSetupWizard from './DataroomSetupWizard';

const SimpleSetupTrigger = ({ projectId, projectName, onSetupComplete }) => {
  const [showWizard, setShowWizard] = useState(false);

  const handleSetupComplete = (setupData) => {
    setShowWizard(false);
    if (onSetupComplete) {
      onSetupComplete(setupData);
    }
  };

  const handleSetupCancel = () => {
    setShowWizard(false);
  };

  return (
    <>
      {/* Simple Setup Banner */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-6">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <Settings className="h-6 w-6 text-blue-600" />
          </div>
          <div className="ml-3 flex-1">
            <h3 className="text-sm font-medium text-blue-800">
              Setup Required
            </h3>
            <div className="mt-2 text-sm text-blue-700">
              <p>Configure bidding organizations, their teams, and user access for this dataroom.</p>
            </div>
            <div className="mt-4">
              <button
                onClick={() => setShowWizard(true)}
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Start Setup
              </button>
            </div>
          </div>
        </div>

        {/* Setup Steps Preview */}
        <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="bg-white rounded-lg p-4 border border-blue-100">
            <div className="flex items-center">
              <Building2 className="h-8 w-8 text-blue-600" />
              <div className="ml-3">
                <h4 className="text-sm font-medium text-gray-900">1. Setup Parties</h4>
                <p className="text-xs text-gray-500 mt-1">Define bidding organizations (e.g., Investment Firm XYZ)</p>
              </div>
            </div>
          </div>
          
          <div className="bg-white rounded-lg p-4 border border-blue-100">
            <div className="flex items-center">
              <Users className="h-8 w-8 text-blue-600" />
              <div className="ml-3">
                <h4 className="text-sm font-medium text-gray-900">2. Configure Teams</h4>
                <p className="text-xs text-gray-500 mt-1">Set up teams within each party (Legal, Finance, Tax, etc.)</p>
              </div>
            </div>
          </div>
          
          <div className="bg-white rounded-lg p-4 border border-blue-100">
            <div className="flex items-center">
              <UserPlus className="h-8 w-8 text-blue-600" />
              <div className="ml-3">
                <h4 className="text-sm font-medium text-gray-900">3. Invite Users</h4>
                <p className="text-xs text-gray-500 mt-1">Add users to parties and teams</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Setup Wizard Modal */}
      {showWizard && (
        <DataroomSetupWizard
          projectId={projectId}
          projectName={projectName}
          onComplete={handleSetupComplete}
          onCancel={handleSetupCancel}
        />
      )}
    </>
  );
};

export default SimpleSetupTrigger;
